const LocalStorage = {
    THEME_KEY: 'space-trade-theme',
    TOKEN_EXP: 'token-exp',
} as const;

export default LocalStorage;
